import styled from '@emotion/styled';
import {Button} from '@mui/joy';
import {Logo as LogoStyle, TextDefault} from '../../shared/styles';
import {ReactComponent as BackArrowSVG} from '../../assets/icons/ic_arrow_left.svg';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100vw;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  gap: ${({theme}) => theme.gap.desktop.xxl};
  padding: ${({theme}) => theme.padding.desktop.lg};
  background-color: ${({theme}) => theme.color.white};
  border-radius: ${({theme}) => theme.border.radius.md};
  box-shadow: ${({theme}) => theme.boxShadow.primary};

  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    min-height: 100vh;
    width: 100vw;
    border-radius: 0;
    background-color: transparent;
  }
`;

export const FormContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xxl};

  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    gap: ${({theme}) => theme.gap.mobile.xl};
  }
`;

// HEADER
export const Header = styled.div`
  width: 100%;
`;

export const LanguageSelectorWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

// This wrapper is positioned absolutely to align the language selector with the top-right corner of the parent container.
// On smaller screens, the position is changed to static to allow for a more flexible layout.
export const LanguageSelectorWrapperWithLogo = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    position: static;
    width: 100%;
    margin-bottom: ${({theme}) => theme.margin.mobile.lg};
    display: flex;
    justify-content: flex-end;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;

  position: relative;

  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    position: static;
    flex-direction: column;
    align-items: center;
  }
`;

export const Logo = styled(LogoStyle)`
  width: 124px;
  height: 124px;

  @media screen and (min-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    width: 200px;
    height: 200px;
  }
`;

// CONTENT
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xl};

  // For large screens, set a specific width
  @media screen and (min-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    width: 700px;
  }
`;

export const TitleContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xxs};
`;

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xl};
`;

export const InputLabel = styled(TextDefault)`
  padding-bottom: 10px;
`;

export const FormControls = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.lg};
`;

export const FormInput = styled.div`
  gap: ${({theme}) => theme.gap.desktop.xxs};
`;

export const IconBack = styled(BackArrowSVG)`
  width: ${({theme}) => theme.icon.size.md};
  height: ${({theme}) => theme.icon.size.md};
  fill: ${({theme}) => theme.color.primary};
`;

export const StyledButton = styled(Button)`
  min-height: 48px;
`;
